import { render, staticRenderFns } from "./StoryShareTab.vue?vue&type=template&id=d85f05a0&scoped=true"
import script from "./StoryShareTab.vue?vue&type=script&lang=js"
export * from "./StoryShareTab.vue?vue&type=script&lang=js"
import style0 from "./StoryShareTab.vue?vue&type=style&index=0&id=d85f05a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85f05a0",
  null
  
)

export default component.exports